'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconRefresh = function IconRefresh(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M12.0007504,20 C7.58915674,20 4,16.6369606 4,12.5 C4,12.1130394 4.3354282,11.7964353 4.75039865,11.7964353 C5.1653691,11.7964353 5.5007973,12.1130394 5.5007973,12.5 C5.5007973,15.8630394 8.41609605,18.5928705 12.0007504,18.5928705 C15.5846543,18.5928705 18.4992027,15.8630394 18.4992027,12.5 C18.4992027,9.1369606 15.5846543,6.40712946 12.0007504,6.40712946 C11.5857799,6.40712946 11.2503517,6.09052533 11.2503517,5.70356473 C11.2503517,5.31660413 11.5857799,5 12.0007504,5 C16.4108433,5 20,8.3630394 20,12.5 C20,16.6369606 16.4108433,20 12.0007504,20' }),
      ' ',
      _react2.default.createElement('path', { d: 'M12.3653435,9 C12.1913792,9 12.0180498,8.91825844 11.8923383,8.75477533 L10.1628535,6.49573597 C9.94571551,6.21335605 9.94571551,5.78235512 10.1628535,5.4999752 L11.8923383,3.24836689 C12.1272536,2.94369382 12.5285144,2.91396961 12.7894609,3.18891848 C13.0497725,3.46386735 13.0719943,3.93202354 12.8377138,4.23669661 L11.4885379,5.99785558 L12.8377138,7.75901456 C13.0719943,8.06368763 13.0497725,8.53184382 12.7894609,8.80679269 C12.6675589,8.9405516 12.5164512,9 12.3653435,9' }),
      ' '
    )
  );
};

IconRefresh.propTypes = {
  color: _propTypes2.default.string
};

IconRefresh.defaultProps = {
  color: _colors2.default.icons
};

IconRefresh.displayName = 'IconRefresh';

exports.default = IconRefresh;
module.exports = exports.default;